const en = {
    actionMemo: {
        event: {
            ADD_APPROVER: '{proxyAsName} added {segment1} as an approver',
            ADD_ATTACHMENT: '{proxyAsName} attached {segment1}',
            ADD_DISTRIBUTION: '{proxyAsName} added {segment1} as a viewer',
            ADD_SIGNER: '{proxyAsName} added {segment1} as a signer',
            APPROVED: 'Approved by {proxyAsName}',
            AUTO_APPROVAL: 'Auto approved',
            CANCELLED: 'Cancelled by {proxyAsName}',
            CHANGED_DATE: '{proxyAsName} changed the completion date',
            CHANGED_COMPLETION_DATE:
                '{proxyAsName} changed the completion date from {segment1} to {segment2}',
            CHANGE_COMPLETION_DATE:
                '{proxyAsName} changed the completion date from {segment1} to {segment2}',
            CLOSED: 'Closed by {proxyAsName}',
            CREATED: 'Created by {proxyAsName}',
            DEACTIVATED: 'Deactivated by {proxyAsName}',
            DELETE_APPROVER: '{proxyAsName} removed {segment1} as an approver',
            DELETE_ATTACHMENT: '{proxyAsName} deleted {segment1}',
            DELETE_DISTRIBUTION: '{proxyAsName} removed {segment1} as a viewer',
            ESCALATED: 'Escalated to the next approver',
            ESCALATED_APPROVER: "{segment1}'s approval was escalated to the next approver",
            FINAL_APPROVAL: 'Final approval by {proxyAsName}',
            HOLD: 'Put on hold by {proxyAsName}',
            MARK_CONFIDENTIAL: 'Marked confidential by {proxyAsName}',
            REACTIVATED: 'Reactivated by {proxyAsName}',
            REJECTED: 'Rejected by {proxyAsName}',
            RELEASED: 'Released by {proxyAsName}',
            REMOVE_SIGNER: '{proxyAsName} removed {segment1} as a signer',
            REOPENED: 'Reopened by {proxyAsName}',
            REPLACE_PROJECT_MANAGER:
                '{proxyAsName} replaced project manager {segment1} with {segment2}',
            REPLACE_SIGNER: '{proxyAsName} replaced signer {segment1} with {segment2}',
            RETURNED: 'Returned by {proxyAsName}',
            ROUTED: '{proxyAsName} routed the action memo to {routedToName}',
            SKIPPED: '{proxyAsName} skipped an approver',
            SKIPPED_APPROVER: '{proxyAsName} skipped {segment1}',
            STATUS_CHANGE_CANCELLED:
                '{proxyAsName} has cancelled the request to change status from {segment1} to {segment2}',
            STATUS_CHANGE_REQUESTED:
                '{proxyAsName} has requested the status to change from {segment1} to {segment2}',
            SUBMITTED: 'Submitted by {proxyAsName}',
            UNMARK_CONFIDENTIAL: 'Unmarked confidential by {proxyAsName}',
            UNSKIPPED_APPROVER: '{proxyAsName} unskipped {segment1}',
            UPDATE_ATTACHMENT: '{proxyAsName} updated {segment1}',
            VOIDED: 'Voided by {proxyAsName}',
            PROXY_AS_USER: '{proxyName} acting as {eventByName}',
        },
    },
};

export default en;
